import React, { useEffect } from "react";
import { usePlaidLink } from "react-plaid-link";
import { uriHasOAuthStateId } from "../../utilities/userInfo";

const LinkBankPlaid = ({
  linkToken,
  fromOauthRedirect,
  fromFinicityConnect,
  boxStyle,
  continueStyle,
  fromFakeDashboard,
  text,
  onSuccess,
  onExit,
  onEvent,
  onLoad,
  overrideButtonClasses,
}) => {
  const fromWebviewOauth = fromOauthRedirect && uriHasOAuthStateId();
  const forceOpen = fromFinicityConnect || fromWebviewOauth;

  console.log(`CURRENT link_token: ${linkToken}`);

  const config = {
    token: linkToken,
    receivedRedirectUri: fromWebviewOauth ? window.location.href : null,
    onSuccess,
    onExit,
    onEvent,
    onLoad,
  };

  // there's options for an error getting read and if we want to force close the modal
  // but can't think of any good reasons why we'd want to do error handling here,
  // mainly it's going to be done at the onEvent hnadler being passed in
  const { open, ready, error, exit } = usePlaidLink(config);

  useEffect(() => {
    // open up the Plaid link automatically for webview users going through oauth
    if (forceOpen && ready)
      open();

  }, [ready, open]);

  const linkBankClasses = boxStyle
    ? "addAccBtn w-full py-2 bg-green-primary text-white text-lg cursor-pointer"
    : continueStyle
      ? "addAccBtn continueButton-noMargin"
      : "w-full text-gray-500 shadow text-3xl font-hairline hover:text-primary hover:border-teal-300 font-medium border-gray-200 border hover:border hover:bg-white";

  const fakeDashboardClasses = boxStyle
    ? "w-full py-2 mr-1 addAccBtn bg-green-primary opacity-75 text-lg text-white"
    : continueStyle
      ? "w-full py-2 mr-1 addAccBtn continueButton-noMargin-dash"
      : "w-full py-2 mr-1 addAccBtn addAccBtn bg-green-primary opacity-75 text-lg text-white";

  const buttonClasses = `gtm-bank-linking-add-account ${
    fromFakeDashboard ? fakeDashboardClasses : linkBankClasses
  }`;
  return (
    <button
      className={overrideButtonClasses || buttonClasses}
      onClick={() => {
        // need to set linkToken passed into this component in localStorage for relinking logic
        localStorage.setItem("plaid_link_token", linkToken);
        open();
      }}
      type="button"
    >
      {continueStyle ? (text || "Continue") : "+"}
    </button>
  );
};

export default LinkBankPlaid;
